import React from 'react';
import CIcon from '@coreui/icons-react';
import TextConstants from "src/common/helpers/TextConstants";
import { basePath as MepbasePath } from 'src/mep/route/routes';

const _nav = [
  {
    _tag: 'CSidebarNavItem',
    name: TextConstants.Dashboard.Title,
    to: '/dashboard',
    icon: <CIcon name="cil-speedometer" customClasses="c-sidebar-nav-icon" />,
  },
  {
    _tag: 'CSidebarNavItem',
    name: TextConstants.DataView.Title,
    to: '/data-view',
    icon: <CIcon name="cil-spreadsheet" customClasses="c-sidebar-nav-icon" />,
  },
  {
    _tag: 'CSidebarNavItem',
    name: TextConstants.LastData.Title,
    to: '/last-data',
    icon: <CIcon name="cil-notes" customClasses="c-sidebar-nav-icon" />,
  },
  {
    _tag: 'CSidebarNavDivider',
  },
  {
    _tag: 'CSidebarNavItem',
    name: TextConstants.DeviceSettings.Title,
    to: '/unit-settings',
    icon: <CIcon name="cil-settings" customClasses="c-sidebar-nav-icon" />,
  },
  {
    _tag: 'CSidebarNavItem',
    name: TextConstants.ChannelSettings.Title,
    to: '/channel-settings',
    icon: <CIcon name="cil-settings" customClasses="c-sidebar-nav-icon" />,
  },
  {
    _tag: 'CSidebarNavItem',
    name: TextConstants.UsersManagement.Title,
    to: '/users-management',
    icon: <CIcon name="cil-user" customClasses="c-sidebar-nav-icon" />,
  },
  {
    _tag: 'CSidebarNavItem',
    name: TextConstants.Mep.Title,
    to: MepbasePath,
    icon: <CIcon name="cil-pencil" customClasses="c-sidebar-nav-icon" />,
  },
];

export default _nav;
